import React, { useRef, useMemo } from 'react';
import { bool, func, string } from 'prop-types';
import { useAuthentication } from '@johnlewispartnership/wtr-website-authentication/dist/context';
import { chainHandlers } from 'utils/chain-handlers';
import { useMenuFocus } from 'components/MegaMenu/MenuFocusProvider';
import config from 'config';

const logoutUrl = `${config.services.tokenClient.path}/v1/logout/oidc`;

// TODO: Merge this component with ./Button/index.js if possible
const SignOut = ({ className, loggedIn, onBlur, onClick, onFocus }) => {
  const { state: authState } = useAuthentication();
  const visible = loggedIn && !authState.isSignedOnAsCustomer;
  const ref = useRef();
  const { handleClick, handleKeyDown, tabIndex } = useMenuFocus(ref, {
    skip: !visible,
  });

  const chainedHandleClick = useMemo(
    () => chainHandlers(handleClick, onClick),
    [handleClick, onClick],
  );

  return visible ? (
    <form action={logoutUrl} method="POST">
      <input type="hidden" name="_csrf" value={authState.tokenServiceCsrfToken} />
      <button
        className={className}
        data-test="signOut"
        onBlur={onBlur}
        onClick={chainedHandleClick}
        onFocus={onFocus}
        onKeyDown={handleKeyDown}
        ref={ref}
        tabIndex={tabIndex}
        type="submit"
      >
        Sign out
      </button>
    </form>
  ) : null;
};

SignOut.propTypes = {
  className: string,
  loggedIn: bool.isRequired,
  onBlur: func,
  onClick: func,
  onFocus: func,
};

SignOut.defaultProps = {
  className: null,
  onBlur: null,
  onClick: null,
  onFocus: null,
};

SignOut.displayName = 'SignOut';

export { SignOut };
